import './App.scss';
import Content from './components/content/Content';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import { useEffect, useState } from 'react'
import Scrollme from './components/scrollme/Scrollme';


import { Helmet, HelmetProvider } from 'react-helmet-async';

export default () => {
  const [scrolledPage, setScrolledPage] = useState(false);
  useEffect(() => {
    const onScroll = (e: any) => {
      const scrollTop = e?.target?.scrollingElement?.scrollTop;
      setScrolledPage(scrollTop && scrollTop > 10);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrolledPage]);

  const helmetContext = {};

  return (
    <HelmetProvider context={helmetContext}>
      <Helmet>
        <title>Dev-Set - Software Solutions</title>
        <meta name="description" content="Dev-Set: Professional software solutions, mobile products, and expert consulting. Over 10 years of experience in the tech industry." />
        <meta name="keywords" content="software solutions, mobile apps, consulting, web development, react, typescript, dev-set" />
        <meta name="author" content="Dev-Set" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dev-set.com/" />
        <meta property="og:title" content="Dev-Set - Software Solutions" />
        <meta property="og:description" content="Professional software solutions, mobile products, and expert consulting." />
        <meta property="og:image" content="https://dev-set.com/logo.png" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://dev-set.com/" />
        <meta property="twitter:title" content="Dev-Set - Software Solutions" />
        <meta property="twitter:description" content="Professional software solutions, mobile products, and expert consulting." />
        <meta property="twitter:image" content="https://dev-set.com/logo.png" />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Dev-Set",
              "url": "https://dev-set.com",
              "logo": "https://dev-set.com/logo.png",
              "description": "Professional software solutions, mobile products, and expert consulting."
            }
          `}
        </script>
      </Helmet>
      <div className='main parallax-background'>
        <Header scrolledPage={scrolledPage} />
        <Content scrolledPage={scrolledPage} />
        {!scrolledPage && <Scrollme />}
        <Footer />
      </div>
    </HelmetProvider>
  );
}
